import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getShiftWorkbench = (unit: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `shift-workbench?where=` + unit
  );
};
export const AddShiftWorkbench = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift-workbench/create`,
    obj,
    { headers }
  );
};
export const EditShiftWorkbench = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift-workbench/edit`,
    obj,
    { headers }
  );
};
export const DeleteShiftWorkbench = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift-workbench/delete`,
    obj,
    { headers }
  );
};
